import { FC } from "react";
import { Router } from "../Router";
import useNotifier from "components/common/Notification/useNotifier";

export const MainView: FC = () => {
  useNotifier();

  return (<Router/>)
}
